import { Component, EventEmitter,  OnDestroy, OnInit, Output} from '@angular/core';

// @ts-ignore
import moment from 'moment';

import {GlnInfoDto} from '../../interface/gln-info.dto';
import {BusinessCodeService} from '../../../../services';
import {CreateChatDto} from '../../interface/create-chat.dto';
import {AngularFireDatabase} from 'angularfire2/database';
import {SendMessagePayloadDto} from '../../interface/send-message-payload.dto';
import {Message} from '../../interface';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'app-conversation-chat',
  templateUrl: './conversation-chat.component.html',
  styleUrls: ['./conversation-chat.component.scss']
})
export class ConversationChatComponent implements OnInit, OnDestroy {
    detailConversations: Message[] ;
    owner: GlnInfoDto;
    client;
    check;
    message = '11' ;
    bodySendMessage: CreateChatDto = new CreateChatDto();
    sendMessage: SendMessagePayloadDto = new SendMessagePayloadDto();
    @Output() removeUnreadCount = new EventEmitter();
    @Output() reloadListChat = new EventEmitter();
  constructor(private businessCodeService: BusinessCodeService, private db: AngularFireDatabase, private http: HttpClient) {
  }

  ngOnDestroy() {

  }
  trackByFn(index, item) {
    return index; // or item.id
  }
  submit() {
    if (this.message.trim()) {
      console.log('this.client' ,  this.client);
      console.log(this.owner);
      this.bodySendMessage.pageId = this.owner.idPage;
      this.bodySendMessage.content = this.message;
      this.bodySendMessage.toUser = this.client.source_id;
      // this.bodySendMessage.businessId = this.owner.id;
      console.log(" this.bodySendMessage",  this.bodySendMessage)
      this.sendMessage.message.text = this.message;
      this.sendMessage.sender.source_id = this.owner.idPage;
      this.sendMessage.sender.type = 'page';
      this.sendMessage.sender_id = `page|${this.owner.idPage}`;
      this.sendMessage.time = +moment().format('x');
      console.log(this.sendMessage);
      this.businessCodeService.addChatConversation(this.bodySendMessage).subscribe(z => {
        this.message = ''
      });
    }
    // this.reloadListChat.emit(this.owner.idPage)
  }
  setDefaultPic(data) {
    document.querySelector<HTMLElement>('.only-img' + data).style.display = 'none';
  }


   ngOnInit(): void {

  }
  removeUnread(value) {
    this.removeUnreadCount.emit(value);
  }

}
